/**
 * @file: useLocalCacheInfo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { calculateCacheSize, clearCache } from '@euler/lib/cache/cacheUtil';
import { onErrorReturn } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { useCallback, useEffect, useState } from 'react';

export const useLocalCacheInfo = () => {
  const [totalSize, setTotalSize] = useState<number>();
  const [loading, setLoading] = useState(true);

  const invalidate = useCallback(() => {
    setLoading(true);
    void calculateCacheSize()
      .then(setTotalSize)
      .catch(onErrorReturn(0))
      .finally(() => setLoading(false));
  }, []);

  const clear = usePersistFn(async () => {
    try {
      setLoading(true);
      await clearCache();
      setTotalSize(0);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    invalidate();
  }, [invalidate]);

  return [totalSize, loading, clear, invalidate] as const;
};
